var _defs, _path, _g, _g2, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrpcIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-3.78 101.47 365.56 156.81",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.448 115.797h34.468v34.468H10.448z",
    className: "cls-1",
    transform: "rotate(-45.213 27.682 133.032)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.176 122.635h20.218v20.218H84.176z",
    className: "cls-1",
    transform: "rotate(-45.213 94.285 132.743)"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-1 {\n                fill: none\n            }\n\n            .cls-2 {\n                fill: #244b5a\n            }\n\n            .cls-4 {\n                fill: #75caca\n            }\n\n            .cls-5 {\n                fill: #74cbca\n            }\n\n            .cls-6 {\n                fill: #73cbca\n            }\n\n            .cls-7 {\n                fill: #72c9c9\n            }\n\n            .cls-8 {\n                fill: #70caca\n            }\n\n            .cls-9 {\n                fill: #6fcac8\n            }\n\n            .cls-10 {\n                fill: #6ec8c8\n            }\n\n            .cls-11 {\n                fill: #6cc9c9\n            }\n\n            .cls-12 {\n                fill: #6dc9c8\n            }\n\n            .cls-13 {\n                fill: #69c7c8\n            }\n\n            .cls-14 {\n                fill: #69c8c7\n            }\n\n            .cls-15 {\n                fill: #68c8c7\n            }\n\n            .cls-16 {\n                fill: #67c7c7\n            }\n\n            .cls-17 {\n                fill: #65c7c7\n            }\n\n            .cls-18 {\n                fill: #64c7c7\n            }\n\n            .cls-19 {\n                fill: #63c6c6\n            }\n\n            .cls-20 {\n                fill: #60c6c6\n            }\n\n            .cls-21 {\n                fill: #60c6c5\n            }\n\n            .cls-22 {\n                fill: #5fc6c5\n            }\n\n            .cls-23 {\n                fill: #5cc5c4\n            }\n\n            .cls-24 {\n                fill: #5ac5c4\n            }\n\n            .cls-25 {\n                fill: #57c4c4\n            }\n\n            .cls-26 {\n                fill: #58c4c3\n            }\n\n            .cls-27 {\n                fill: #55c4c3\n            }\n\n            .cls-28 {\n                fill: #53c3c2\n            }\n\n            .cls-29 {\n                fill: #52c3c2\n            }\n\n            .cls-30 {\n                fill: #50c3c2\n            }\n\n            .cls-31 {\n                fill: #50c1c0\n            }\n\n            .cls-34 {\n                fill: #47c1be\n            }\n\n            .cls-35 {\n                fill: #46c0be\n            }\n\n            .cls-36 {\n                fill: #43c0be\n            }\n\n            .cls-37 {\n                fill: #40bfbd\n            }\n\n            .cls-38 {\n                fill: #3bbfbd\n            }\n\n            .cls-39 {\n                fill: #39bfbc\n            }\n\n            .cls-40 {\n                fill: #34bebd\n            }\n\n            .cls-41 {\n                fill: #32bebb\n            }\n\n            .cls-42 {\n                fill: #2dbdbb\n            }\n\n            .cls-43 {\n                fill: #24bcbb\n            }\n\n            .cls-44 {\n                fill: #21bcb9\n            }\n\n            .cls-45 {\n                fill: #18bbb9\n            }\n\n            .cls-47 {\n                fill: #03bbb8\n            }\n\n            .cls-48 {\n                fill: #06b8b6\n            }\n\n            .cls-49 {\n                fill: #03b7b5\n            }\n\n            .cls-50 {\n                fill: #04b7b4\n            }\n\n            .cls-51 {\n                fill: #00b6b5\n            }\n\n            .cls-52 {\n                fill: #03b6b4\n            }\n\n            .cls-53 {\n                fill: #05b6b2\n            }\n\n            .cls-54 {\n                fill: #01b5b1\n            }\n\n            .cls-55 {\n                fill: #00b4b1\n            }\n\n            .cls-56 {\n                fill: #00b3b0\n            }\n\n            .cls-62 {\n                fill: #00afac\n            }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.241 232.21a27.645 27.645 0 009.905 8.2 29.688 29.688 0 0013.579 3.082 29.168 29.168 0 0011.151-1.902 19.357 19.357 0 007.412-5.181 19.987 19.987 0 004.068-7.676 34.278 34.278 0 001.246-9.379v-11.02h-.262a23.66 23.66 0 01-10.234 8.92 31.568 31.568 0 01-12.725 2.624 33.097 33.097 0 01-12.529-2.361 31.868 31.868 0 01-10.168-6.494 29.88 29.88 0 01-6.822-9.905 31.084 31.084 0 01-2.493-12.463 32.602 32.602 0 012.362-12.464 32.038 32.038 0 016.494-10.102 29.29 29.29 0 019.84-6.756 31.698 31.698 0 0112.529-2.428 35.035 35.035 0 015.837.525 27.644 27.644 0 016.166 1.837 28.405 28.405 0 0111.743 9.446h.262V158.48h8.659v60.874a49.392 49.392 0 01-1.247 10.626 26.247 26.247 0 01-4.854 10.364 27.642 27.642 0 01-10.036 7.872q-6.43 3.147-16.793 3.148a42.18 42.18 0 01-16.399-3.017 38.112 38.112 0 01-13.12-9.315zm1.574-43.818a23.507 23.507 0 001.772 9.117 23.952 23.952 0 004.853 7.479 23.472 23.472 0 007.216 5.117 21.233 21.233 0 008.987 1.902 24.066 24.066 0 0016.53-6.494 20.9 20.9 0 005.051-7.413 23.878 23.878 0 001.64-9.708 26.12 26.12 0 00-1.574-9.118 21.9 21.9 0 00-4.592-7.478 22.19 22.19 0 00-7.347-5.116 23.914 23.914 0 00-9.708-1.902 21.253 21.253 0 00-8.987 1.902 23.537 23.537 0 00-7.216 5.116 24.006 24.006 0 00-4.853 7.478 23.526 23.526 0 00-1.772 9.118zm89.735 31.486h-9.445v-92.885h28.6q14.168 0 22.368 6.166 8.198 6.17 8.2 18.63a23.21 23.21 0 01-6.1 16.334q-6.102 6.626-17.646 7.674l26.763 44.081h-11.545l-25.452-43.162H133.55zm0-51.821h16.793a37.748 37.748 0 0010.692-1.312 19.857 19.857 0 007.019-3.476 12.696 12.696 0 003.805-5.117 16.977 16.977 0 001.18-6.363 16.63 16.63 0 00-1.18-6.231 13.202 13.202 0 00-3.805-5.183 18.556 18.556 0 00-7.02-3.476 39.7 39.7 0 00-10.691-1.247H133.55zm69.006-41.064h27.027q14.167 0 22.367 6.166 8.198 6.17 8.2 18.63 0 12.465-8.2 18.695-8.2 6.232-22.367 6.232h-17.58v43.162h-9.447zm9.447 41.064h15.218a37.758 37.758 0 0010.692-1.312 19.868 19.868 0 007.02-3.476 12.7 12.7 0 003.803-5.117 16.964 16.964 0 001.181-6.363 16.618 16.618 0 00-1.18-6.231 13.207 13.207 0 00-3.805-5.183 18.565 18.565 0 00-7.019-3.476 39.71 39.71 0 00-10.692-1.247h-15.218zM355 205.185a36.025 36.025 0 01-5.837 6.69 36.897 36.897 0 01-7.938 5.445 45.27 45.27 0 01-9.642 3.608 44.556 44.556 0 01-10.955 1.312 49.688 49.688 0 01-19.22-3.673 46.107 46.107 0 01-25.517-25.583 53.854 53.854 0 010-39.096 46.101 46.101 0 0125.518-25.582 49.676 49.676 0 0119.219-3.674 46.957 46.957 0 0117.317 3.411 34.933 34.933 0 0114.825 11.283l-8.265 6.166a22.616 22.616 0 00-3.936-4.46 28.736 28.736 0 00-5.706-3.936 35.626 35.626 0 00-6.888-2.755 26.65 26.65 0 00-7.347-1.05 37.68 37.68 0 00-16.005 3.28 36.35 36.35 0 00-12.004 8.79 38.667 38.667 0 00-7.545 12.791 45.832 45.832 0 000 30.568 38.65 38.65 0 007.545 12.79 36.304 36.304 0 0012.004 8.79 37.64 37.64 0 0016.005 3.28 40.558 40.558 0 007.28-.654 30.242 30.242 0 007.086-2.23 26.807 26.807 0 006.56-4.265 31.615 31.615 0 005.706-6.756z",
    className: "cls-2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.74 108.66l-.431 3.816v-3.816h.431z",
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.311 108.66l-1.002 8.86v-5.044l.431-3.816h.571z",
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.88 108.66l-1.571 13.902v-5.042l1.002-8.86h.569z",
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45 108.66l-2.141 18.945v-5.043L4.88 108.66h.57z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02 108.66l-2.711 23.988v-5.043L5.45 108.66h.57z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59 108.66l-3.281 29.032v-5.044L6.02 108.66h.57z",
    className: "cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.16 108.66l-3.851 34.075v-5.043L6.59 108.66h.57z",
    className: "cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.729 108.66l-4.42 39.118v-5.043L7.16 108.66h.569z",
    className: "cls-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.299 108.66l-4.99 44.161v-5.043l4.42-39.118h.57z",
    className: "cls-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.87 108.66l-5.505 48.714-.056-.006v-4.547l4.99-44.161h.571z",
    className: "cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.439 108.66l-5.508 48.744h-.302l-.264-.03L8.87 108.66h.569z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.008 108.66l-5.507 48.744h-.57l5.508-48.744h.569z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.579 108.66l-5.508 48.744h-.57l5.507-48.744h.571z",
    className: "cls-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.149 108.66l-5.508 48.744h-.57l5.508-48.744h.57z",
    className: "cls-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.718 108.66l-5.507 48.744h-.57l5.508-48.744h.569z",
    className: "cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.288 108.66L6.78 157.404h-.569l5.507-48.744h.57z",
    className: "cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.858 108.66L7.35 157.404h-.57l5.508-48.744h.57z",
    className: "cls-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.428 108.66L7.92 157.404h-.57l5.508-48.744h.57z",
    className: "cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.997 108.66L8.49 157.404h-.57l5.508-48.744h.569z",
    className: "cls-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.567 108.66L9.06 157.404h-.57l5.507-48.744h.57z",
    className: "cls-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.138 108.66l-5.509 48.744H9.06l5.507-48.744h.571z",
    className: "cls-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.707 108.66l-5.508 48.744h-.57l5.509-48.744h.569z",
    className: "cls-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.277 108.66l-5.507 48.744h-.571l5.508-48.744h.57z",
    className: "cls-20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.846 108.66l-5.507 48.744h-.569l5.507-48.744h.569z",
    className: "cls-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.417 108.66l-5.508 48.744h-.57l5.507-48.744h.571z",
    className: "cls-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.987 108.66l-5.508 48.744h-.57l5.508-48.744h.57z",
    className: "cls-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.556 108.66l-5.507 48.744h-.57l5.508-48.744h.569zm.57 0l-5.508 48.744h-.569l5.507-48.744h.57z",
    className: "cls-24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.696 108.66l-5.508 48.744h-.57l5.508-48.744h.57z",
    className: "cls-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.266 108.66l-5.508 48.744h-.57l5.508-48.744h.57z",
    className: "cls-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.835 108.66l-5.507 48.744h-.57l5.508-48.744h.569z",
    className: "cls-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.405 108.66l-5.508 48.744h-.569l5.507-48.744h.57z",
    className: "cls-28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.975 108.66l-5.508 48.744h-.57l5.508-48.744h.57z",
    className: "cls-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.545 108.66l-5.508 48.744h-.57l5.508-48.744h.57z",
    className: "cls-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.114 108.66l-5.507 48.744h-.57l5.508-48.744h.569z",
    className: "cls-31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4bc2c0",
    d: "M23.685 108.66l-5.508 48.744h-.57l5.507-48.744h.571z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4cc1c0",
    d: "M24.255 108.66l-5.508 48.744h-.57l5.508-48.744h.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.824 108.66l-5.508 48.744h-.569l5.508-48.744h.569z",
    className: "cls-34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.394 108.66l-5.507 48.744h-.571l5.508-48.744h.57z",
    className: "cls-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.964 108.66l-5.508 48.744h-.569l5.507-48.744h.57z",
    className: "cls-36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.534 108.66l-5.508 48.744h-.57l5.508-48.744h.57z",
    className: "cls-37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.104 108.66l-5.508 48.744h-.57l5.508-48.744h.57z",
    className: "cls-38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.673 108.66l-5.507 48.744h-.57l5.508-48.744h.569z",
    className: "cls-39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.243 108.66l-5.508 48.744h-.569l5.507-48.744h.57z",
    className: "cls-40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.813 108.66l-5.508 48.744h-.57l5.508-48.744h.57z",
    className: "cls-41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.383 108.66l-5.507 48.744h-.571l5.508-48.744h.57z",
    className: "cls-42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.952 108.66l-5.507 48.744h-.569l5.507-48.744h.569z",
    className: "cls-43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.523 108.66l-5.509 48.744h-.569l5.507-48.744h.571z",
    className: "cls-44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.093 108.66l-5.509 48.744h-.57l5.509-48.744h.57z",
    className: "cls-45"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0fbab9",
    d: "M31.662 108.66l-5.507 48.744h-.571l5.509-48.744h.569z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.231 108.66l-5.507 48.744h-.569l5.507-48.744h.569z",
    className: "cls-47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.802 108.66l-5.508 48.744h-.57l5.507-48.744h.571z",
    className: "cls-48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.372 108.66l-5.508 48.744h-.57l5.508-48.744h.57z",
    className: "cls-48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.941 108.66l-5.507 48.744h-.57l5.508-48.744h.569z",
    className: "cls-49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.511 108.66l-5.507 48.744h-.57l5.507-48.744h.57z",
    className: "cls-50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.081 108.66l-5.508 48.744h-.569l5.507-48.744h.57z",
    className: "cls-51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.651 108.66l-5.508 48.744h-.57l5.508-48.744h.57z",
    className: "cls-52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.221 108.66l-5.508 48.744h-.57l5.508-48.744h.57z",
    className: "cls-53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.79 108.66l-5.507 48.744h-.57l5.508-48.744h.569z",
    className: "cls-54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.361 108.66l-5.509 48.744h-.569l5.507-48.744h.571z",
    className: "cls-54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.93 108.66l-5.508 48.744h-.57l5.509-48.744h.569z",
    className: "cls-55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 108.66l-5.507 48.744h-.571l5.508-48.744h.57z",
    className: "cls-56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.07 108.66l-5.508 48.744h-.569L38.5 108.66h.57z",
    className: "cls-56"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00b2af",
    d: "M39.64 108.66l-5.508 48.744h-.57l5.508-48.744h.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00b2ae",
    d: "M40.21 108.66l-5.509 48.744h-.569l5.508-48.744h.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00b1ae",
    d: "M40.779 108.66l-5.507 48.744h-.571l5.509-48.744h.569z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00b1ad",
    d: "M41.349 108.66l-5.508 48.744h-.569l5.507-48.744h.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00b0ac",
    d: "M41.919 108.66l-5.508 48.744h-.57l5.508-48.744h.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.489 108.66l-5.507 48.744h-.571l5.508-48.744h.57z",
    className: "cls-62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.735 108.66l.319.035v48.709H36.982l5.507-48.744h9.246z",
    className: "cls-62"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.581 126.799l-.389-8.352h.389v8.352z",
    className: "cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.581 135.574l-.797-17.127h.408l.389 8.352v8.775z",
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.581 144.349l-1.207-25.902h.41l.797 17.127v8.775z",
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.298 147.04l-1.332-28.593h.408l1.207 25.902v2.691h-.283z",
    className: "cls-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.888 147.04l-1.331-28.593h.409l1.332 28.593h-.41z",
    className: "cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.48 147.04l-1.331-28.593h.408l1.331 28.593h-.408z",
    className: "cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.071 147.04l-1.331-28.593h.409l1.331 28.593h-.409z",
    className: "cls-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.663 147.04l-1.332-28.593h.409l1.331 28.593h-.408z",
    className: "cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.254 147.04l-1.332-28.593h.409l1.332 28.593h-.409zm-.409 0l-1.331-28.593h.408l1.332 28.593h-.409z",
    className: "cls-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.437 147.04l-1.333-28.593h.41l1.331 28.593h-.408z",
    className: "cls-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.028 147.04l-1.332-28.593h.408l1.333 28.593h-.409z",
    className: "cls-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.62 147.04l-1.333-28.593h.409l1.332 28.593h-.408zm-.41 0l-1.331-28.593h.408l1.333 28.593h-.41z",
    className: "cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.802 147.04l-1.332-28.593h.409l1.331 28.593h-.408z",
    className: "cls-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.393 147.04l-1.332-28.593h.409l1.332 28.593h-.409z",
    className: "cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.985 147.04l-1.333-28.593h.409l1.332 28.593h-.408z",
    className: "cls-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.576 147.04l-1.332-28.593h.408l1.333 28.593h-.409z",
    className: "cls-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.167 147.04l-1.331-28.593h.408l1.332 28.593h-.409z",
    className: "cls-18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.758 147.04l-1.331-28.593h.409l1.331 28.593h-.409z",
    className: "cls-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.349 147.04l-1.331-28.593h.409l1.331 28.593h-.409z",
    className: "cls-20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.94 147.04l-1.331-28.593h.409l1.331 28.593h-.409z",
    className: "cls-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.532 147.04L99.2 118.447h.409l1.331 28.593h-.408z",
    className: "cls-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.123 147.04l-1.332-28.593h.409l1.332 28.593h-.409z",
    className: "cls-22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.715 147.04l-1.332-28.593h.408l1.332 28.593h-.408z",
    className: "cls-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.305 147.04l-1.331-28.593h.409l1.332 28.593h-.41z",
    className: "cls-24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.897 147.04l-1.331-28.593h.408l1.331 28.593h-.408z",
    className: "cls-24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.489 147.04l-1.333-28.593h.41l1.331 28.593h-.408z",
    className: "cls-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.08 147.04l-1.332-28.593h.408l1.333 28.593h-.409z",
    className: "cls-26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.672 147.04l-1.333-28.593h.409l1.332 28.593h-.408z",
    className: "cls-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.262 147.04l-1.331-28.593h.408l1.333 28.593h-.41z",
    className: "cls-28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.854 147.04l-1.332-28.593h.409l1.331 28.593h-.408z",
    className: "cls-28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.444 147.04l-1.331-28.593h.409l1.332 28.593h-.41z",
    className: "cls-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.036 147.04l-1.332-28.593h.409l1.331 28.593h-.408z",
    className: "cls-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.627 147.04l-1.331-28.593h.408l1.332 28.593h-.409z",
    className: "cls-31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4dc2c1",
    d: "M95.219 147.04l-1.332-28.593h.409l1.331 28.593h-.408z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4cc2c0",
    d: "M94.81 147.04l-1.332-28.593h.409l1.332 28.593h-.409z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4bc0bf",
    d: "M94.401 147.04l-1.331-28.593h.408l1.332 28.593h-.409z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.992 147.04l-1.331-28.593h.409l1.331 28.593h-.409z",
    className: "cls-34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.584 147.04l-1.332-28.593h.409l1.331 28.593h-.408z",
    className: "cls-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.175 147.04l-1.332-28.593h.409l1.332 28.593h-.409z",
    className: "cls-36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#41c0be",
    d: "M92.767 147.04l-1.332-28.593h.408l1.332 28.593h-.408z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.357 147.04l-1.331-28.593h.409l1.332 28.593h-.41z",
    className: "cls-37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.949 147.04l-1.331-28.593h.408l1.331 28.593h-.408z",
    className: "cls-38"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3cbfbc",
    d: "M91.54 147.04l-1.332-28.593h.41l1.331 28.593h-.409z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.132 147.04L89.8 118.447h.408l1.332 28.593h-.408z",
    className: "cls-39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.722 147.04l-1.331-28.593h.409l1.332 28.593h-.41z",
    className: "cls-40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.314 147.04l-1.331-28.593h.408l1.331 28.593h-.408z",
    className: "cls-41"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2fbebc",
    d: "M89.906 147.04l-1.332-28.593h.409l1.331 28.593h-.408z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.497 147.04l-1.332-28.593h.409l1.332 28.593h-.409z",
    className: "cls-42"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2bbdba",
    d: "M89.088 147.04l-1.332-28.593h.409l1.332 28.593h-.409z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.679 147.04l-1.331-28.593h.408l1.332 28.593h-.409z",
    className: "cls-43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.271 147.04l-1.333-28.593h.41l1.331 28.593h-.408z",
    className: "cls-44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.862 147.04l-1.332-28.593h.408l1.333 28.593h-.409z",
    className: "cls-45"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#16bab9",
    d: "M87.453 147.04l-1.332-28.593h.409l1.332 28.593h-.409z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#11bab7",
    d: "M87.044 147.04l-1.331-28.593h.408l1.332 28.593h-.409z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.636 147.04l-1.332-28.593h.409l1.331 28.593h-.408z",
    className: "cls-47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.227 147.04l-1.332-28.593h.409l1.332 28.593h-.409z",
    className: "cls-48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.819 147.04l-1.332-28.593h.408l1.332 28.593h-.408z",
    className: "cls-48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.409 147.04l-1.331-28.593h.409l1.332 28.593h-.41z",
    className: "cls-48"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00b7b6",
    d: "M85.001 147.04l-1.331-28.593h.408l1.331 28.593h-.408z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.592 147.04l-1.331-28.593h.409l1.331 28.593h-.409z",
    className: "cls-49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.183 147.04l-1.331-28.593h.409l1.331 28.593h-.409z",
    className: "cls-50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.774 147.04l-1.331-28.593h.409l1.331 28.593h-.409z",
    className: "cls-51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.366 147.04l-1.332-28.593h.409l1.331 28.593h-.408z",
    className: "cls-51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.957 147.04l-1.332-28.593h.409l1.332 28.593h-.409z",
    className: "cls-51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.549 147.04l-1.332-28.593h.408l1.332 28.593h-.408z",
    className: "cls-52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.14 147.04l-1.332-28.593h.409l1.332 28.593h-.409z",
    className: "cls-52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.731 147.04L80.4 118.447h.408l1.332 28.593h-.409z",
    className: "cls-53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.323 147.04l-1.333-28.593h.41l1.331 28.593h-.408z",
    className: "cls-54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.914 147.04l-.925-19.852v-8.741h.001l1.333 28.593h-.409z",
    className: "cls-54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.506 147.04l-.517-11.077v-8.775l.925 19.852h-.408z",
    className: "cls-54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.096 147.04l-.107-2.302v-8.775l.517 11.077h-.41z",
    className: "cls-55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.989 144.738l.107 2.302h-.107v-2.302z",
    className: "cls-55"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.663 118.295L13.959 133.11l14.813 14.704 12.533-.046-13.142-13.037 64.895-.24-5.688 5.726 6.267-.023 7.353-7.408-7.408-7.351-6.266.022 5.73 5.685-64.895.241 13.044-13.135-12.532.047z",
    className: "cls-2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrpcIcon);
export default __webpack_public_path__ + "static/media/grpc-icon.894f626a.svg";
export { ForwardRef as ReactComponent };